import s from './MobileFloatingCTA.module.scss';
import InstagramLogo from '../components/InstagramLogo';
import LineLogo from '../components/LineLogo';
import { INSTAGRAM_URL, LINE_URL } from '../config/socialLinks';
import { trackCtaClick } from '../utils/analytics';

const MobileFloatingCTA = () => {
  return (
    <div className={s.root}>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noreferrer"
        className={s.instagram}
        onClick={() => trackCtaClick({
          label: 'instagram_mobile_floating',
          placement: 'mobile_floating_cta',
          destination: INSTAGRAM_URL,
          destinationType: 'external_social',
        })}
      >
        <InstagramLogo white />
        <span>Instagramで相談</span>
      </a>

      <a
        href={LINE_URL}
        target="_blank"
        rel="noreferrer"
        className={s.line}
        onClick={() => trackCtaClick({
          label: 'line_mobile_floating',
          placement: 'mobile_floating_cta',
          destination: LINE_URL,
          destinationType: 'external_booking',
        })}
      >
        <LineLogo white />
        <span>LINEで予約する</span>
      </a>
    </div>
  );
};

export default MobileFloatingCTA;
